import CareerSection from './career-section';

export default class Career {
  constructor(data) {
    this.id = null;
    this.location = [];
    this.name = null;
    this.url = null;
    this.action = null;
    this.description = null;
    this.text = [];
    // Initialize data
    if (data) {
      Object.assign(this, {
        id: data.Slug,
        location: data.Locations,
        name: data.Name,
        url: data.CallToAction,
        action: data.CallToActionLabel,
        description: data.description,
        text: data.Sections ? data.Sections.map((item) => new CareerSection(item)) : []
      });
    }
  }
}



// WEBPACK FOOTER //
// src/entities/career.js